import { IconButton, styled, Typography } from '@mui/material'
import { MessageMenuIcon } from '../menu-icon'
import { getWappTheme } from '$common/wapp-bar-theme'

const Root = styled('div')`
  display: flex;
  width: 100%;
  height: 44px;
  padding: 0 5px;
  background-color: white;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  border-bottom: 1px solid #e6e6e6;
`
const Title = styled(Typography)`
  /* @noflip */
  margin-right: 8px;
`

const StyledIconButton = styled(IconButton)`
  width: 20px;
  height: 20px;
`

export function WappBar({
  wappId,
  roomId,
  iid,
}: {
  wappId: string
  roomId: string
  iid: number
}) {
  const theme = getWappTheme(wappId) // can fetch this from wapp manifest?
  return (
    <Root>
      <div style={{ display: 'flex' }}>
        {theme.icon}

        <Title
          variant="subtitle1"
          sx={{ lineHeight: '23px', color: theme.color }}
        >
          {theme.name}
        </Title>
      </div>

      <MessageMenuIcon
        roomId={roomId}
        iid={iid}
        IconButton={StyledIconButton}
      />
    </Root>
  )
}
